// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sp-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1099;
}

.sp-panel {
  position: fixed;
  right: 0;
  top: 0;
  width: min(900px, 90vw);
  height: 100vh;
  background: #fff;
  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.18);
  z-index: 1100;
  display: flex;
  flex-direction: column;
  transform: translateX(100%);
  transition: transform 0.28s ease;
  overflow: hidden;
}

.sp-panel--open {
  transform: translateX(0);
}

.sp-hd {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 13px 20px;
  border-bottom: 1px solid #e0e0e0;
  background: #f5f7fa;
  flex-shrink: 0;
}

.sp-title {
  font-size: 14px;
  font-weight: 600;
  color: #1a1a1a;
}

.sp-close-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 17px;
  color: #666;
  padding: 4px 8px;
  border-radius: 4px;
  line-height: 1;
}

.sp-close-btn:hover {
  background: #e8e8e8;
  color: #333;
}

.sp-body {
  flex: 1 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 14px 18px;
}

/* 탭 버튼 (SidePanel 내부에서 사용) */
.sp-tab-btns {
  display: flex;
  gap: 2px;
  margin-bottom: 14px;
  border-bottom: 2px solid #e0e0e0;
}

.sp-tab-btn {
  padding: 7px 16px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 13px;
  color: #666;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
}

.sp-tab-btn.active {
  color: #1565c0;
  border-bottom-color: #1565c0;
  font-weight: 600;
}

/* 공통 테이블 (SidePanel 내) */
.sp-tbl {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.sp-tbl th {
  background: #f0f2f5;
  padding: 7px 8px;
  text-align: center;
  font-weight: 600;
  color: #444;
  border-bottom: 2px solid #d0d5dd;
  white-space: nowrap;
}

.sp-tbl td {
  padding: 7px 8px;
  border-bottom: 1px solid #f0f0f0;
  white-space: nowrap;
}

.sp-tbl tr:hover td {
  background: #fafbfe;
}

.sp-tbl .num { text-align: right; }
.sp-tbl .ctr { text-align: center; }
.sp-tbl .pos { color: #c62828; }
.sp-tbl .neg { color: #1565c0; }
.sp-tbl .neu { color: #888; }

/* 계좌 소계 행 */
.sp-subtotal-row td {
  background: #f0f0f0;
  font-weight: bold;
  border-top: 1px solid #ccc;
}

.sp-subtotal-row:hover td { background: #e8e8e8; }

/* 전체 합계 행 */
.sp-total-row td {
  background: #d0d0d0;
  font-weight: bold;
  border-top: 2px solid #bbb;
}

.sp-total-row:hover td { background: #c8c8c8; }

.sp-summary-row {
  display: flex;
  justify-content: flex-end;
  gap: 24px;
  padding: 10px 4px 4px;
  font-size: 13px;
  font-weight: 600;
  color: #333;
}

.sp-empty {
  text-align: center;
  padding: 40px;
  color: #aaa;
  font-size: 13px;
}

.sp-loading {
  text-align: center;
  padding: 40px;
  color: #999;
  font-size: 13px;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/SidePanel.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,MAAM;EACN,uBAAuB;EACvB,aAAa;EACb,gBAAgB;EAChB,2CAA2C;EAC3C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,eAAe,iBAAiB,EAAE;AAClC,eAAe,kBAAkB,EAAE;AACnC,eAAe,cAAc,EAAE;AAC/B,eAAe,cAAc,EAAE;AAC/B,eAAe,WAAW,EAAE;;AAE5B,YAAY;AACZ;EACE,mBAAmB;EACnB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA,4BAA4B,mBAAmB,EAAE;;AAEjD,YAAY;AACZ;EACE,mBAAmB;EACnB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA,yBAAyB,mBAAmB,EAAE;;AAE9C;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,eAAe;AACjB","sourcesContent":[".sp-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.3);\n  z-index: 1099;\n}\n\n.sp-panel {\n  position: fixed;\n  right: 0;\n  top: 0;\n  width: min(900px, 90vw);\n  height: 100vh;\n  background: #fff;\n  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.18);\n  z-index: 1100;\n  display: flex;\n  flex-direction: column;\n  transform: translateX(100%);\n  transition: transform 0.28s ease;\n  overflow: hidden;\n}\n\n.sp-panel--open {\n  transform: translateX(0);\n}\n\n.sp-hd {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 13px 20px;\n  border-bottom: 1px solid #e0e0e0;\n  background: #f5f7fa;\n  flex-shrink: 0;\n}\n\n.sp-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #1a1a1a;\n}\n\n.sp-close-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 17px;\n  color: #666;\n  padding: 4px 8px;\n  border-radius: 4px;\n  line-height: 1;\n}\n\n.sp-close-btn:hover {\n  background: #e8e8e8;\n  color: #333;\n}\n\n.sp-body {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 14px 18px;\n}\n\n/* 탭 버튼 (SidePanel 내부에서 사용) */\n.sp-tab-btns {\n  display: flex;\n  gap: 2px;\n  margin-bottom: 14px;\n  border-bottom: 2px solid #e0e0e0;\n}\n\n.sp-tab-btn {\n  padding: 7px 16px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 13px;\n  color: #666;\n  border-bottom: 2px solid transparent;\n  margin-bottom: -2px;\n}\n\n.sp-tab-btn.active {\n  color: #1565c0;\n  border-bottom-color: #1565c0;\n  font-weight: 600;\n}\n\n/* 공통 테이블 (SidePanel 내) */\n.sp-tbl {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12px;\n}\n\n.sp-tbl th {\n  background: #f0f2f5;\n  padding: 7px 8px;\n  text-align: center;\n  font-weight: 600;\n  color: #444;\n  border-bottom: 2px solid #d0d5dd;\n  white-space: nowrap;\n}\n\n.sp-tbl td {\n  padding: 7px 8px;\n  border-bottom: 1px solid #f0f0f0;\n  white-space: nowrap;\n}\n\n.sp-tbl tr:hover td {\n  background: #fafbfe;\n}\n\n.sp-tbl .num { text-align: right; }\n.sp-tbl .ctr { text-align: center; }\n.sp-tbl .pos { color: #c62828; }\n.sp-tbl .neg { color: #1565c0; }\n.sp-tbl .neu { color: #888; }\n\n/* 계좌 소계 행 */\n.sp-subtotal-row td {\n  background: #f0f0f0;\n  font-weight: bold;\n  border-top: 1px solid #ccc;\n}\n\n.sp-subtotal-row:hover td { background: #e8e8e8; }\n\n/* 전체 합계 행 */\n.sp-total-row td {\n  background: #d0d0d0;\n  font-weight: bold;\n  border-top: 2px solid #bbb;\n}\n\n.sp-total-row:hover td { background: #c8c8c8; }\n\n.sp-summary-row {\n  display: flex;\n  justify-content: flex-end;\n  gap: 24px;\n  padding: 10px 4px 4px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #333;\n}\n\n.sp-empty {\n  text-align: center;\n  padding: 40px;\n  color: #aaa;\n  font-size: 13px;\n}\n\n.sp-loading {\n  text-align: center;\n  padding: 40px;\n  color: #999;\n  font-size: 13px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
